export const generatePages = (count, ext = "jpg") => {
  return Array.from({ length: count }, (_, i) => {
    const pageNum = String(i + 1).padStart(4, "0");
    return `/ebook/book1/updesh-sudha_page-${pageNum}.${ext}`;
  });
};

export const generatePagesBook2 = (count = 196, ext = "jpg") => {
  return Array.from({ length: count }, (_, i) => {
    const pageNum = i + 1; // Simple numeric naming (1, 2, 3…)
    return `/ebook/book2/${pageNum}.${ext}`;
  });
};

export const generatePagesBook3 = (count = 27, ext = "jpg") => {
  return Array.from({ length: count }, (_, i) => {
    const pageNum = i + 1; // Simple numeric naming (1, 2, 3…)
    return `/ebook/book3/${pageNum}.${ext}`;
  });
};

export const generatePagesBook4 = (count = 78, ext = "jpg") => {
  return Array.from({ length: count }, (_, i) => {
    const pageNum = i + 1; // Simple numeric naming (1, 2, 3…)
    return `/ebook/book4/${pageNum}.${ext}`;
  });
};

export const generatePagesBook5 = (count = 152, ext = "jpg") => {
  return Array.from({ length: count }, (_, i) => {
    const pageNum = i + 0; // Simple numeric naming (1, 2, 3…)
    return `/ebook/book5/${pageNum}.${ext}`;
  });
};

export const generatePagesBook6 = (count = 121, ext = "jpg") => {
  return Array.from({ length: count }, (_, i) => {
    const pageNum = i + 0; // Simple numeric naming (1, 2, 3…)
    return `/ebook/book6/${pageNum}.${ext}`;
  });
};

export const generatePagesBook7 = (count = 188, ext = "jpg") => {
  return Array.from({ length: count }, (_, i) => {
    const pageNum = i + 1; // Simple numeric naming (1, 2, 3…)
    return `/ebook/book7/${pageNum}.${ext}`;
  });
};

const booksData = [
  {
    id: 1,
    cover: "/ebook/book1/1.jpeg",
    pages: [
      "/ebook/book1/1.jpeg",
      "/ebook/book1/2.jpeg",
      "/ebook/book1/3.jpg",
      "/ebook/book1/4.jpg",
      "/ebook/book1/5.jpg",
      "/ebook/book1/6.jpg",
      ...generatePages(117, "jpg"),  // <- change "jpg" if your files are .jpeg or .png
      "/ebook/book1/118.jpg",
      "/ebook/book1/119.jpg"
    ],
    // description: "A deep insight into the spiritual teachings of Gurudev.",
  },
  {
    id: 2,
    cover: "/ebook/book2/1.jpg",
    pages: [
      ...generatePagesBook2(196, "jpg"),  // <- change "jpg" if your files are .jpeg or .png
    ],
    // description: "Explore the divine philosophy of inner peace and wisdom.",
  },
  {
    id: 3,
    cover: "/ebook/book3/1.jpg",
    pages: [
      ...generatePagesBook3(27, "jpg"),  // <- change "jpg" if your files are .jpeg or .png
    ],
    // description: "Explore the divine philosophy of inner peace and wisdom.",
  },
  {
    id: 4,
    cover: "/ebook/book4/1.jpg",
    pages: [
      ...generatePagesBook4(78, "jpg"),  // <- change "jpg" if your files are .jpeg or .png
    ],
    // description: "Explore the divine philosophy of inner peace and wisdom.",
  },
  {
    id: 5,
    cover: "/ebook/book5/0.jpg",
    pages: [
      ...generatePagesBook5(152, "jpg"),  // <- change "jpg" if your files are .jpeg or .png
    ],
    // description: "Explore the divine philosophy of inner peace and wisdom.",
  },
  {
    id: 5,
    cover: "/ebook/book6/0.jpg",
    pages: [
      ...generatePagesBook6(121, "jpg"),  // <- change "jpg" if your files are .jpeg or .png
    ],
    // description: "Explore the divine philosophy of inner peace and wisdom.",
  },
  {
    id: 5,
    cover: "/ebook/book7/1.jpg",
    pages: [
      ...generatePagesBook7(188, "jpg"),  // <- change "jpg" if your files are .jpeg or .png
    ],
    // description: "Explore the divine philosophy of inner peace and wisdom.",
  },
];

export default booksData;
